import { render, staticRenderFns } from "./invitePage.vue?vue&type=template&id=54452870&"
import script from "./invitePage.vue?vue&type=script&lang=js&"
export * from "./invitePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports